var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 300 300",
    height: "300px",
    id: "Layer_1",
    viewBox: "0 0 300 300",
    width: "300px",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "   M225.646,137H75.726C59.033,137,44,149.269,44,165.962v43.525c0,2.003,3.124,4.513,5.127,4.513h203.118   c2.004,0,2.755-2.51,2.755-4.513v-43.525C255,149.269,242.339,137,225.646,137z",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M255,176.627c0-2.003-1.624-3.627-3.627-3.627H47.627c-2.003,0-3.627,1.624-3.627,3.627v33.746c0,2.003,1.624,3.627,3.627,3.627   h203.746c2.003,0,3.627-1.624,3.627-3.627V176.627z",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M237,126V71.657c0-2.003-0.887-2.657-2.891-2.657H67.263C65.26,69,63,69.654,63,71.657V126",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    x1: 44,
    x2: 44,
    y1: 195,
    y2: 231
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    x1: 255,
    x2: 255,
    y1: 195,
    y2: 231
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M199.539,125.908c0-8.987,1.927-18.451,1.927-18.451c0-1.595-1.294-3.046-2.89-3.046c0,0-8.986,1.846-17.812,1.846   c-8.826,0-18.774-1.965-18.774-1.965c-1.597,0-2.891,1.273-2.891,2.869c0,0,1.927,9.128,1.927,18.757",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M140.346,125.908c0-8.987,1.926-18.451,1.926-18.451c0-1.595-1.294-3.046-2.889-3.046c0,0-8.987,1.846-17.812,1.846   c-8.827,0-18.775-1.965-18.775-1.965c-1.597,0-2.889,1.273-2.889,2.869c0,0,1.925,9.128,1.925,18.757",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.56217425756751d275d5bb26e6590b84.svg";
export { ForwardRef as ReactComponent };